import { render, staticRenderFns } from "./admins-inactive.component.html?vue&type=template&id=1d6a2736&scoped=true&external"
import script from "./admins-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./admins-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admins-inactive.component.scss?vue&type=style&index=0&id=1d6a2736&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a2736",
  null
  
)

export default component.exports